import fetch from 'auth/FetchInterceptor'

const AgencyPaymentsService = {}

AgencyPaymentsService.fetch = function (params = {}) {
	return fetch({
		url: '/agency-payments',
		method: 'get',
		params
	})
}

AgencyPaymentsService.create = function (data) {
	return fetch({
		url: '/agency-payments',
		method: 'post',
		data
	})
}

AgencyPaymentsService.update = function (id, data) {
	return fetch({
		url: `/agency-payments/${id}`,
		method: 'put',
		data
	})
}

export default AgencyPaymentsService